import {
  type BrandProfilesListQuery,
  useBrandProfilesListQuery,
} from "src/graphql/types";
import {
  resolveSelection,
  toSelectionParam,
} from "src/components/selection-filter/selection-filter";
import { useSelectionParam } from "src/pages/context-hub/components/knowledge-list/use-selection-filter-param";

// Singular for links from before the filter took several profiles.
const BRAND_PROFILE_FILTER_PARAM_KEY = "brandProfileId";

// Declared outside the hook so the `select` reference is stable across renders.
const selectBrandProfiles = (data: BrandProfilesListQuery) =>
  data.brand_profiles;

/**
 * The Knowledge lists' brand-profile filter, held in the URL. A `null`
 * selection is unfiltered and an empty one matches nothing.
 */
export function useBrandProfileFilter() {
  const { data: brandProfiles, isLoading } = useBrandProfilesListQuery(
    undefined,
    { select: selectBrandProfiles },
  );
  const [rawIds, setRawIds] = useSelectionParam(BRAND_PROFILE_FILTER_PARAM_KEY);
  const ids = brandProfiles?.map((profile) => profile.id);

  // Ids of deleted profiles drop once the list has loaded. Checking before it
  // loads would flash the unfiltered list on every deep link.
  const brandProfileIds = ids ? resolveSelection(rawIds, ids) : rawIds;
  const setBrandProfileIds = (next: string[]) =>
    setRawIds(ids ? toSelectionParam(next, ids) : next);

  return {
    brandProfiles,
    isLoadingBrandProfiles: isLoading,
    brandProfileIds,
    setBrandProfileIds,
  };
}
